// extracted by mini-css-extract-plugin
export default {"container":"BackgroundText_container__eBP23","text":"BackgroundText_text__fDNuy","Main":"BackgroundText_Main__VUBpM","Background":"BackgroundText_Background__b-Jy4"};